{
  "dropLabel": "Sasa‘a i se fesili fa‘apitoa",
  "nextLabel": "<b>Tali fesili e uiga i le soifua mālōlōina</b>",
  "questions": {
    "allergies": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le Igilisi. Mo se fa‘ata‘ita‘iga:<br/>\nPenicillin – rash and swelling; Latex – mild irritation",
      "label": "E i ai ni ou ma‘i oona (allergies)?",
      "nextLabel": "$t(common:next): <b>Mamafa ma le maualuga</b>",
      "title": "<h3>Ogaoga i ni vailaʻau po’o mea’ai (Allergies)</h3>"
    },
    "arrhythmias": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>Irregular heartbeat, on beta blockers since 2021",
      "label": "E iai sau fatu le masani, fatu tata vave, po o se leo i le fatu?",
      "nextLabel": "$t(common:next): <b>Masini fatu</b>",
      "title": "<h3>Tapuaiga o le fatu e le masani ai (Arrhythmias)</h3>"
    },
    "asthmaLungConditions": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga:<br/>\nMild asthma – use inhaler occasionally",
      "label": "E iai sau asima, COPD, po’o se isi fo’i ma’i mama?",
      "nextLabel": "$t(common:next): <b>Gāioiga o le manava</b>",
      "title": "<h3>Asima poʻo nisi maʻi o le mama (Asthma or lung conditions)</h3>"
    },
    "bloodProblems": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>\nEasy bruising – diagnosed with Von Willebrand disease",
      "label": "E iai sau GORD (reflux), IBS, po’o le IBD?",
      "nextLabel": "$t(common:next): <b>Fesuia’iga o totoga</b>",
      "title": "<h3>Mataupu tau le toto e pei o le pala toto po’o le tafe toto faifai pea (Blood disorders or bleeding problems)</h3>"
    },
    "bloodThinningMedication": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>Apixaban – 5mg daily, last taken on 3 June",
      "label": "O e inuina nei ni fualaʻau e faaitiitia ai le maaa o le toto?",
      "nextLabel": "$t(common:next): <b>aʻi fatu</b>",
      "title": "<h3>Fualaʻau fa’amama toto (Blood thinning medication)</h3>"
    },
    "cancerTreatment": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>\nChemotherapy for breast cancer – ongoing",
      "label": "O lo’o e faia togafitiga mo le kanesa e pei o le chemotherapy, radiotherapy po’o se isi foi togafitiga?",
      "nextLabel": "$t(common:next): <b>Fa’ama’i pipisi</b>",
      "title": "<h3>Togafitiga o le kanesa (Cancer treatment)</h3>"
    },
    "diabetes": {
      "detailsLabel": "E faʻafefea ona faʻatautaia lau suka?",
      "diet-controlled": "Pulea i le taumafataga",
      "insulin": "Inisalini",
      "label": "E iai sau maʻisuka?",
      "nextLabel": "$t(common:next): <b>Faatosinaga toto maualuga</b>",
      "no": "Leai",
      "tablets": "Fualaʻau i luga o le laulau (faʻataʻitaʻiga: Metformin)",
      "title": "<h3>Maʻi suka (Diabetes)</h3>",
      "type-1": "Ituaiga 1 – fa’aaogaina le inisalini",
      "type-2": "Ituaiga 2",
      "yes-type-1": "Ioe – Ituaiga 1, i le insulin",
      "yes-type-2": "Ioe – Ituaiga 2"
    },
    "digestiveConditions": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga:<br/>Reflux managed with omeprazole",
      "label": "E iai sau GORD (reflux), IBS, po’o le IBD?",
      "nextLabel": "$t(common:next): <b>Fa’afitauli o le toto po’o le tafe toto</b>",
      "title": "<h3>Gāfa o le manava (Digestive conditions)</h3>"
    },
    "epilepsy": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le Igilisi. Mo se fa‘ata‘ita‘iga:<br/>\nLast seizure in 2020 – currently stable",
      "label": "E iai sau epilepsi po o sau tala‘aga i le mā‘i fifi?",
      "nextLabel": "$t(common:next): <b>Gāfua o le neulosi</b>",
      "title": "<h3>Fa’ama’i fatu (Epilepsy)</h3>"
    },
    "heartConditions": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>Heart attack in 2020 – stent inserted",
      "label": "Pe na iai se fa’afitauli o lou fatu i le taimi ua tuana’i (fa’ata’ita’iga, fatu ta, angina)?",
      "nextLabel": "$t(common:next): <b>Taʻavale po o le TIA</b>",
      "title": "<h3>Fomaʻi o le fatu (Heart conditions)</h3>"
    },
    "highBloodPressure": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>\nDiagnosed in 2018 – managed with medication",
      "label": "E iai sau toto maualuga?",
      "nextLabel": "$t(common:next): <b>Fua fatu le masani</b>",
      "title": "<h3>Faatosinaga maualuga o le toto (High blood pressure)</h3>"
    },
    "infectiousDiseases": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>\nMRSA – cleared after treatment in 2021",
      "label": "Na e maua se i’uga lelei mo MRSA, ESBL, VRE po’o le CPE?",
      "nextLabel": "$t(common:next): <b>maʻitaga</b>",
      "title": "<h3>Siama e tetee i vailaʻau eseese (Multi-resistant organisms)</h3>"
    },
    "metalImplants": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>Right hip replacement (2020), dental implants, or metal rod in leg",
      "label": "E i ai ni mea uʻamea i totonu o lou tino? (faʻataʻitaʻiga: pacemaker poʻo ni sooga faʻapipiʻi)",
      "nextLabel": "$t(common:next): <b>Maʻi suka</b>",
      "title": "<h3>Faatomuaga poʻo uʻamea (Implants or metal)</h3>"
    },
    "obstructiveSleepApnoea": {
      "detailsPlaceholder": "Fa'amolemole tu'u i le Igilisi. Fa'ata'ita'iga:<br/>\nDiagnosed in 2022 – use CPAP machine every night",
      "label": "E iai sau obstructive sleep apnoea pe e fa’aaoga se masini CPAP i le pō a’o e moe ai?",
      "nextLabel": "$t(common:next): <b>Ma’i sela po’o ma’i o le mama</b>",
      "title": "<h3>O le tapunia o le ala mānava i le pō (Obstructive Sleep Apnoea)</h3>"
    },
    "organTransplant": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>\nKidney transplant in 2018 – taking tacrolimus and prednisone",
      "label": "Na e fai se tui aano (organ transplant) ma ua e fa’aaogaina fuala’au e fa’aitiitia ai le puipuiga o le tino?",
      "nextLabel": "$t(common:next): <b>Togafitiga o le kanesa</b>",
      "title": "<h3>Faʻapipiʻi o totoga (Organ transplant)</h3>"
    },
    "otherHealthConditions": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le gagana Peretania. Fa‘ata‘ita‘iga: <br/>\nCoeliac disease, recent surgery, chronic pain",
      "label": "E i ai ni isi o ou tulaga tau soifua mālōlōina poʻo ni popolega e tatau ona matou silafia ai?",
      "nextLabel": "$t(common:next): <b>Fualaʻau</b>",
      "title": "<h3>Isi tulaga tau soifua mālōlōina (Other health conditions)</h3>"
    },
    "pacemaker": {
      "defibrillator": "Meafaigaluega fa’aola fatu",
      "detailsLabel": "O le ā le ituaiga?",
      "label": "E iai sau pacemaker poʻo se isi masini fatu faʻapipiʻi i totonu?",
      "nextLabel": "$t(common:next): <b>Fualaʻau fa’amama toto</b>",
      "not-sure": "Ou te le mautinoa",
      "pacing": "Peseina",
      "title": "<h3>Pacemaker po’o se masini fatu ua fa’apipi’iina i totonu (Pacemaker or implanted cardiac device)</h3>"
    },
    "pregnancy": {
      "label": "O e maʻitaga i le taimi nei – pe masalo o e maʻitaga?",
      "nextLabel": "$t(common:next): <b>Isi auga</b>",
      "title": "<h3>Faʻatupu teine (Pregnancy)</h3>"
    },
    "stroke": {
      "detailsPlaceholder": "Fa‘amolemole tusi i le Igilisi. Mo se fa‘ata‘ita‘iga:<br/>\nStroke in 2021 – mild weakness on left side",
      "label": "Na e maua muamua i se stroke po’o se mini-stroke (TIA)?",
      "nextLabel": "$t(common:next): <b>Fa‘amai o le fai‘ai (Epilepsy)</b>",
      "title": "<h3>Fasi o le fai‘ai poʻo le fasi itiiti (TIA)</h3>"
    },
    "weightHeight": {
      "cm": "cm",
      "height": "Maualuga",
      "kg": "kg",
      "nextLabel": "$t(common:next): <b>Faatuʻutuʻu / uʻamea</b>",
      "text": "Fa‘amolemole, ulufale i lou mamafa ma lou maualuga fuafuaina.",
      "title": "<h3>Mamafa ma le maualuga</h3><p>Fa‘amolemole, ulufale i lou mamafa ma lou maualuga fuafuaina.</p>",
      "weight": "Mamafa"
    }
  },
  "text": "<p>O le a tatou lata i le fa’ai’uga.</p>\n<p>E tatau ona matou fesili i ni fesili e uiga i lou soifua mālōlōina, fualaʻau, ma ou mana’oga patino.</p>\n<p>E tāua tele le malamalama i so’o se mea e mafai ona a’afia ai lau tausiga.</p>\n<p>Afai e manaʻomia ona fa’amalamalama se mea, o le a fa’afeso’ota’i oe e se tagata o le matou ‘au a’o le’i faia le taotoga.</p>\n<p>E masani ona umi le vaega mulimuli e itiiti ifo i le <strong>10 minute</strong>.</p>",
  "title": "Fesili e uiga i le soifua mālōlōina ma mana’oga"
}
